import { GraphQLClient } from 'graphql-request';
import { renameKeys } from './mappers/hashmaps';

const graphqlQuery = async ({ url, query, variables }) => {
  try {
    // RCP-725 - access token needs to be stored somewhere (e.g. global vars) and for each environment
    const accessToken = api_config.contentStackAccessToken;
    const graphQLClient = new GraphQLClient(url, { headers: { access_token: accessToken } });
    const data = await graphQLClient.request(query, variables);
    return renameKeys(data);
  } catch (err) {
    throw new Error('Failed to query ContentStack using GraphQL', err);
  }
};

export default graphqlQuery;
